import { Center, Divider, Text, useBreakpointValue } from "@chakra-ui/react";
import { Image } from "@chakra-ui/react";

import RowedDescription from "../../components/rowedDescription";

const Description = () => {
  return (
    <>
      <Text
        fontWeight={700}
        lineHeight={1.2}
        fontSize={useBreakpointValue({ base: "3xl", md: "5xl" })}
        pb={6}
      >
        ⛷️SKI & SNB Sportteam Camp 2027🏂
      </Text>

      <Text mt={3}>
        SKI & SNB Sportteam Camp 2027 to zimowe obozy sportowe
        narciarsko-snowboardowe
      </Text>

      <Divider my={3} />

      <Text my={5}>
        <b>Campy odbędą się w dwóch turnusach:</b>
      </Text>
      {RowedDescription({
        rows: [
          ["SKI & SNB Camp I", "(31.01 - 06.02.2027)"],
          ["SKI & SNB Camp II", "(06.02 - 12.02.2027)"],
        ],
      })}

      <Divider />
      <Center>
        <Text my={5}>
          <b>Zapraszamy do zapisów!</b>
        </Text>
      </Center>
      <Image
        src={"/images/winter2026-1.jpeg"}
        alt="wintercamp"
        objectFit="cover"
      />
    </>
  );
};

export default Description;
